import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

type PropTypes = {
  isReady: boolean;
  duration?: number;
};

export const useHighlightElement = ({
  isReady,
  duration = 3000,
}: PropTypes) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const urlId = searchParams.get('highlight');

  const [activeHighlightId, setActiveHighlightId] = useState<string | null>(
    null
  );

  useEffect(() => {
    if (urlId && isReady) {
      setActiveHighlightId(urlId);

      const timer = setTimeout(() => {
        setActiveHighlightId(null);
        searchParams.delete('highlight');
        setSearchParams(searchParams, { replace: true });
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [urlId, isReady, duration, searchParams, setSearchParams]);

  return { urlId, activeHighlightId };
};
